<!-- PDF预览 -->
<template>
  <div class="pdf-review">
    <div id="pdf-content"></div>
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css';
export default {
  name: 'PdfReview',
  data() {
    return {
      pdfh5: null
    };
  },
  mounted() {
    this.initPdf();
  },
  methods: {
    initPdf() {
      console.log('子组件的地址', this.$route.query);
      // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以操作pdf，监听相关事件
      this.pdfh5 = new Pdfh5('#pdf-content', {
        pdfurl: this.$route.query.reportUrl
      });
      this.pdfh5.scrollEnable(true); // 允许pdf滚动
      // 监听pdf准备开始渲染，可以拿到pdf总页数
      this.pdfh5.on('ready', function () {
        console.log('总页数:' + this.totalNum);
      });
      // 监听pdf加载完成事件
      this.pdfh5.on('complete', (status, msg, time) => {
        console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pdf-review {
  width: 100vw;
  height: 100vh;
  #pdf-content {
    width: 100%;
    height: 100%;
  }
}
</style>
